module.exports = __webpack_public_path__ + "static/media/Badge_Download_on_App_Store.76f7880c.png";